import React from "react";
import Container from 'react-bootstrap/Container';
import '../Lg.css';
import {TildaB} from "./common/TildaB";
import {calcWhere} from "./common/LgHelper";
import {appdata} from "../../../logic_tmp/appdata/AppData";


export function LgShortHeader() {

    return (<div>
        <Container>
            <TildaB>
                <span className="normal">Мы собираемся организовать этот концерт в </span>
                <strong><span><strong
                    className="normal">{calcWhere(appdata)}.</strong></span></strong>
            </TildaB>
        </Container>
    </div>);
}

